var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadFile = function SvgUploadFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 910.6 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436.6 262.7c4.6-5.6 11.5-9 18.8-9s14.2 3.3 18.8 9l273.9 337.9c3.8 4.3 6.1 9.9 6.1 16 0 13.4-10.8 24.2-24.1 24.2h-174v335c0 13.4-10.8 24.2-24.2 24.2H378.7c-13.4 0-24.2-10.8-24.2-24.2V640.7H180.7c-9.3 0-17.8-5.4-21.8-13.8s-2.8-18.4 3-25.6zM0 144.7h910.6V0H0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFile);
export default ForwardRef;